import { useState } from 'react';

import GenericPropertyInput from '../../../FlowDesigner/Components/Inputs/GenericPropertyInput';
import { TabModel } from '../../Models/TabModel';
import TabsItemsInputContent from './TabsItemsInputContent';
import { TabsItemsInputDialog } from './TabsItemsInputDialog';

type TabsItemsInputProps = {
	tabs: TabModel[] | undefined;
	onTabsChange: (tabs: TabModel[] | undefined) => void;
};

export default function TabsItemsInput({ tabs, onTabsChange }: TabsItemsInputProps) {
	const [open, setOpen] = useState(false);

	return (
		<GenericPropertyInput value={tabs} onValueChange={onTabsChange} onOpen={() => setOpen(true)}>
			<TabsItemsInputContent value={tabs} />
			{open && <TabsItemsInputDialog open={open} setOpen={setOpen} tabs={tabs} onTabsChange={onTabsChange} />}
		</GenericPropertyInput>
	);
}
